<div style="margin: 30px">
	<div>
		<div style="text-align: left; font: normal normal bold 22px/12px Montserrat; letter-spacing: -0.53px; color: #333333; opacity: 1; margin-bottom: 10px;">
			Services & Fares
		</div>
		<div style="text-align: left; font: normal normal medium 16px/12px Montserrat; letter-spacing: -0.38px; color: #333333; opacity: 0.5;margin-bottom: 30px;">
			Here’s all services and fares on Ride category.
		</div>
	</div>
	<div style="cursor: pointer" class="flex flex-row">
		<img (click)="showEditMenu(1)" src="/XpressApp/assets/images/service-moto.png" style="margin-right: 30px" />
		<img (click)="showEditMenu(2)" src="/XpressApp/assets/images/service-car.png" style="margin-right: 30px" />
		<img (click)="showEditMenu(3)" src="/XpressApp/assets/images/service-suv.png" />
	</div>
	<div>
		<services-and-fares-edit [serviceType]="serviceType" [showPopup]="showInfoPopup" [onHide]="handleInfoPopupHide"></services-and-fares-edit>
	</div>

</div>

